module.exports = __webpack_public_path__ + "img/four2Red.08593d4c.jpg";